module.exports = __webpack_public_path__ + "static/img/xsb.b07ec71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xsb.png
// module id = H/4Y
// module chunks = 0